const STEP_TYPES = {
  COMPLETED: 'completed',
  CURRENT: 'current',
  NOT_STARTED: 'not_started',
};

export default STEP_TYPES;
